const Path = Object.freeze({
  GENERIC: "/signup/*",
  PROFILE: "/signup/profile",
  ADDRESS: "/signup/address",
  ADMIN: "/signup/administrator",
  SUBMIT: "/signup/submit",
});

export { Path };
